import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { X, Settings, Check, Copy } from "lucide-react";
import Select from "react-select";
import Calendar from "./calendar";
import ModalHojaDeRuta from "./modal-hoja-de-ruta";
import { obtenerTodasLasUnidades } from "../api/gestion-dts/gestion";
import { obtenerListaFormulario } from "../api/api-formulario";
import moment from "moment";
import { ASIGNACION_FROM, VERSION_ASIGNACION } from "../page/asignacion/const/version";
import { dividirAsignacion } from "../api/api-asignacion";
import shortid from "shortid";
import { ID_EMPRESA, ID_ESTADOS_POR_EMPRESA } from "../utils/const/empresa-const";
import { STRING_ID_EMPRESA_ULTIMA_MILLA_V3 } from "../utils/const/string-const";
import ModalFormularioRetornoMercaderia from "./modal-formulario-retorno-mercaderia";
import { obtenerInfoConductorConNumeroPlaca } from "../api/api-usuario-movil";
import ModalHojaDeRutaTiemposEntrega from "./modal-hoja-de-ruta-tiempos-entrega";
/**
 * Detail panel component for seguimiento page
 * Displays a list of items with lat/lng coordinates
 * 
 * @param {boolean} isOpen - Whether the panel is visible
 * @param {Function} onClose - Callback to close the panel
 * @param {Array} items - Array of items to display with lat/lng
 * @param {Function} onItemClick - Callback when an item is clicked, receives (item) => void
 */
export default function DetailPanelSeguimiento({
    isOpen = false,
    showToast,
    onClose,
    items = [],
    onItemClick,
    itemSelected,
    geocercasSelected = null,
    tipoClientesSelected = null,
    setProcessingVisible,
    handleRuteoClick,
    selectedDate,
    btnConfiguracionPedido = false,
}) {
    const { t } = useTranslation();
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedItems, setSelectedItems] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [hojaDeRutaModalVisible, setHojaDeRutaModalVisible] = useState(false);
    const [hojaDeRutaTiemposEntregaModalVisible, setHojaDeRutaTiemposEntregaModalVisible] = useState(false);
    const [forceUpdate, setForceUpdate] = useState(0);
    const dropdownRef = useRef(null);
    const buttonRef = useRef(null);

    const [listaVehiculos, setListaVehiculos] = useState([]);
    const [vehiculoSelected, setVehiculoSelected] = useState(null);
    const [fechaSelected, setFechaSelected] = useState(null);
    const [listaFormulario, setListaFormulario] = useState([]);
    const [formularioSelected, setFormularioSelected] = useState(null);

    const idEmpresa = localStorage.getItem(STRING_ID_EMPRESA_ULTIMA_MILLA_V3);

    const [modalFormularioRetornoVisible, setModalFormularioRetornoVisible] = useState(false);
    const [rowsFormularioRetorno, setRowsFormularioRetorno] = useState([]);

    const [infoConductor, setInfoConductor] = useState(null);


    useEffect(() => {
        if (!isOpen) {
            setSelectedItem(null);
            setSelectedItems([]);
            setDropdownOpen(false);
            setModalVisible(false);
            setHojaDeRutaModalVisible(false);
            setHojaDeRutaTiemposEntregaModalVisible(false);
            setForceUpdate(0);
        }
        if (isOpen) {
            obtenerDatos();
        }
    }, [isOpen]);

    const obtenerDatos = async () => {
        try {
            const unidades = await obtenerTodasLasUnidades();
            setListaVehiculos(unidades);
            const formularios = await obtenerListaFormulario({}, true, t);
            setListaFormulario(formularios);
            const responseInfoConductor = await obtenerInfoConductorConNumeroPlaca({ valuePlaca: itemSelected?.valuePlaca });
            if (responseInfoConductor.error === false) {
                setInfoConductor(responseInfoConductor.data);
            }
        } catch (err) {
            console.log('obtenerDatos err');
            console.log(err);
        }
    };

    // Listen for geocercasSelected and tipoClientesSelected changes and auto-select matching items
    useEffect(() => {
        const hasGeocercas = geocercasSelected !== null && geocercasSelected !== undefined &&
            Array.isArray(geocercasSelected) && geocercasSelected.length > 0;
        const hasTipoClientes = tipoClientesSelected !== null && tipoClientesSelected !== undefined &&
            Array.isArray(tipoClientesSelected) && tipoClientesSelected.length > 0;
        // console.log('hasTipoClientes');
        // console.log(hasTipoClientes);
        // console.log('tipoClientesSelected');
        // console.log(tipoClientesSelected);
        // If neither filter is active, clear selection
        if (!hasGeocercas && !hasTipoClientes) {
            setSelectedItems([]);
            return;
        }

        // Extract values from filter arrays
        const geocercaValues = hasGeocercas ? geocercasSelected.map(geocerca => geocerca.value) : [];
        const tipoClienteValues = hasTipoClientes ? tipoClientesSelected.map(tipoCliente => tipoCliente.value) : [];

        // console.log('tipoClienteValues');
        // console.log(tipoClienteValues);
        // Filter items based on active filters
        const matchingItems = items.filter(item => {
            // console.log('item');
            // console.log(item);
            let matchesGeocerca = true;
            let matchesTipoCliente = true;

            // Check geocerca condition if geocercasSelected has items
            if (hasGeocercas) {
                matchesGeocerca = item.idGeocerca && geocercaValues.includes(item.idGeocerca);
            }

            // Check tipoCliente condition if tipoClientesSelected has items
            if (hasTipoClientes) {
                matchesTipoCliente = item.idTipoCliente && tipoClienteValues.includes(item.idTipoCliente);
            }

            // Item must match all active filter conditions (AND logic)
            return matchesGeocerca && matchesTipoCliente;
        });
        // console.log('matchingItems');
        // console.log(matchingItems);
        // Use numeroDocumento as the selection key (matches checkbox / modal lookups)
        const matchingItemIds = matchingItems.map(item => item.numeroDocumento);
        setSelectedItems(matchingItemIds);
    }, [geocercasSelected, tipoClientesSelected, items]);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                buttonRef.current &&
                !dropdownRef.current.contains(event.target) &&
                !buttonRef.current.contains(event.target)
            ) {
                setDropdownOpen(false);
            }
        };

        if (dropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownOpen]);

    /**
     * Handle click on a client item in the detail panel
     * Flow: handleItemClickCliente -> onItemClick (prop) -> handleDetailItemClick (in parent)
     * This triggers the map to center on the clicked item's coordinates
     */
    const handleItemClickCliente = (item) => {
        // console.log('handleItemClickCliente');
        // console.log(item);
        setSelectedItem(item);
        if (onItemClick) {
            // This will trigger handleDetailItemClick in the parent component
            // which will center the map on item.latitud and item.longitud
            onItemClick(item);
        }
    };

    const handleCheckboxChange = (itemId, event) => {
        event.stopPropagation(); // Prevent triggering the item click
        setSelectedItems(prev => {
            if (prev.includes(itemId)) {
                return prev.filter(id => id !== itemId);
            } else {
                return [...prev, itemId];
            }
        });
    };

    const handleInvertirClick = () => {
        setDropdownOpen(false);
        const allItemIds = items.map(item => item.numeroDocumento);
        const unselectedItemIds = allItemIds.filter(id => !selectedItems.includes(id));
        setSelectedItems(unselectedItemIds);
    };

    const handleDividirClick = () => {
        try {
            setDropdownOpen(false);
            if (selectedItems.length === 0) {
                if (showToast) {
                    showToast(t("alert_debe_seleccionar_al_menos_un_elemento"));
                }
                return;
            }
            // console.log('selectedItems');
            // console.log(selectedItems);
            // console.log('items');
            // console.log(items);
            const listaItems = [...items];
            for (let i = 0; i < listaItems.length; i++) {
                // const item = items.find(item => item.idCliente === selectedItems[i]);
                const element = listaItems[i];
                listaItems[i].numeroDocumentoNuevo = element.numeroDocumento + "-1";
                // console.log('element');
                // console.log(element);
            }
            items = listaItems;
            setModalVisible(true);
        } catch (err) {
            console.log('handleDividirClick err');
            console.log(err);
        }
    };

    const renderCliente = (item, index) => {
        // console.log('renderCliente');
        // console.log(item);
        const isChecked = selectedItems.includes(item.numeroDocumento);
        return (
            <div
                key={shortid.generate()}
                onClick={() => handleItemClickCliente(item)}
                className={`p-3 mb-2 rounded-lg cursor-pointer transition-colors border border-l-4 flex gap-3 ${selectedItem?.idCliente === item.idCliente
                    ? "bg-blue-200 border-blue-400 hover:bg-blue-300 shadow-md"
                    : "bg-gray-50 border-gray-200 hover:bg-gray-100"
                    }`}
                style={{ borderLeftColor: item.colorEstadoActual }}
            >
                <div className="flex items-center justify-center flex-shrink-0 w-8">
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) => {
                            e.stopPropagation();
                            console.log('item');
                            console.log(item);
                            handleCheckboxChange(item.numeroDocumento, e);
                        }}
                        // onClick={(e) => e.stopPropagation()}
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                    />
                </div>
                <div className="flex-1 min-w-0 flex flex-col gap-2">
                    <div className="flex items-center gap-2">
                        <div className="text-center font-semibold text-gray-700 text-sm">
                            {index + 1}
                        </div>
                        {item.cliente && (
                            <div className="text-sm text-gray-600">
                                {item.cliente}
                            </div>
                        )}
                    </div>
                    {item.geocerca && (
                        <div className="text-xs text-gray-500">
                            {t("label_geocerca")}: {item.geocerca}
                        </div>
                    )}
                    {item.tipoCliente && (
                        <div className="text-xs text-gray-500">
                            {item.tipoCliente}
                        </div>
                    )}
                    {item.numeroDocumento && (
                        <div className="text-xs text-gray-500">
                            {item.numeroDocumento}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const handleAceptarModalClick = async () => {
        try {
            // console.log('selectedItems');
            // console.log(selectedItems);
            if (vehiculoSelected === null || fechaSelected === null || formularioSelected === null) {
                if (showToast) {
                    showToast(t("alert_debe_seleccionar_vehiculo_fecha_formulario"));
                    return;
                }
                return;
            }
            if (moment(fechaSelected).isValid() === false) {
                if (showToast) {
                    showToast(t("alert_fecha_invalida"));
                    return;
                }
                return;
            }
            //how to validate that selectedItems[index].numeroDocumentoNuevo is not empty and !== undefined and !== null and !== 0
            const selectedItemsArray = selectedItems.map(id => items.find(item => item.numeroDocumento === id)).filter(item => item !== undefined);
            // console.log('Selected items array:', selectedItemsArray);
            const isNumeroDocumentoNuevoValid = selectedItemsArray.every(item => item.numeroDocumentoNuevo !== undefined && item.numeroDocumentoNuevo !== null && String(item.numeroDocumentoNuevo).toString().trim().length > 0);
            if (isNumeroDocumentoNuevoValid === false) {
                if (showToast) {
                    showToast(t("alert_debe_ingresar_numero_documento"));
                    return;
                }
                return;
            }

            // const idDetallePedido = selectedItemsArray.map(item => item.idDetallePedido);
            // console.log('idDetallePedido:', idDetallePedido);
            const numeroDocumentoNuevo = selectedItemsArray.map(item => item.numeroDocumentoNuevo);
            const numeroDocumento = selectedItemsArray.map(item => item.numeroDocumento);
            const detallePedido = [];
            for (let i = 0; i < selectedItemsArray.length; i++) {
                detallePedido.push({
                    numeroDocumentoNuevo: numeroDocumentoNuevo[i],
                    numeroDocumento: numeroDocumento[i],
                });
            }
            const objEnviar = {
                idPedido: selectedItemsArray[0].idPedido,
                numeroDocumento: numeroDocumento,
                numeroDocumentoNuevo: numeroDocumentoNuevo,
                detallePedido: detallePedido,
                valuePlaca: vehiculoSelected.value,
                labelPlaca: vehiculoSelected.label,
                fechaEntrega: fechaSelected,
                idFormulario: formularioSelected.value,
                version: VERSION_ASIGNACION,
                from: ASIGNACION_FROM.DIVIDIR,
            };
            // console.log('objEnviar:', objEnviar);
            // window.location.reload();
            // return;
            setModalVisible(false);
            setProcessingVisible(true);
            const response = await dividirAsignacion(objEnviar);
            setProcessingVisible(false);
            if (response.error === false) {
                showToast(t("alert_se_dividio_correctamente"));
                window.location.reload();
                return;
            }
            if (response.error === true) {
                showToast(response.message);
            }
        } catch (err) {
            console.log('handleAceptarModalClick err');
            console.log(err);
        } finally {

        }
    };

    const handleHojaDeRutaClick = () => {
        try {
            // console.log('handleHojaDeRutaClick', items);
            setHojaDeRutaModalVisible(true);
        } catch (err) {
            console.log('handleHojaDeRutaClick err', err);
        } finally {
            setDropdownOpen(false);
        }
    };

    const handleFormularioRetornoClick = () => {
        try {
            // console.log('handleFormularioRetornoClick', items);
            let listaPedidos = [];
            if (String(idEmpresa).trim() === String(ID_EMPRESA.PLASTICO).trim()) {
                listaPedidos = items.filter(item => item.idEstadoActual === ID_ESTADOS_POR_EMPRESA.PLASTICO.ENTREGA_PARCIAL);
            }
            if (String(idEmpresa).trim() === String(ID_EMPRESA.SECOBOL).trim()) {
                listaPedidos = items.filter(item => item.idEstadoActual === ID_ESTADOS_POR_EMPRESA.SECOBOL.ENTREGA_PARCIAL);
            }
            // console.log('listaPedidos', listaPedidos);
            setRowsFormularioRetorno(listaPedidos);
            setModalFormularioRetornoVisible(true);
        } catch (err) {
            console.log('handleFormularioRetornoClick err', err);
        } finally {
            setDropdownOpen(false);
        }
    };

    const handleCopiarHojaDeRutaClick = () => {
        try {
            // console.log('handleCopiarHojaDeRutaClick', items);
            let whatsapp = itemSelected?.labelPlaca;
            whatsapp += '\n' + items
                .map((item, index) => `${index + 1}. ${item.cliente}`)
                .join('\n');
            // console.log('whatsapp', whatsapp);
            navigator.clipboard.writeText(whatsapp).then(() => {
                if (showToast) {
                    showToast(t("alert_copiado_al_portapapeles"));
                }
            }).catch(err => {
                console.error('Failed to copy:', err);
            });
        } catch (err) {
            console.log('handleCopiarHojaDeRutaClick err', err);
        } finally {
            setDropdownOpen(false);
        }
    };

    if (!isOpen) {
        return null;
    }

    return (
        <div className="h-full flex flex-col bg-white border-l border-gray-200 relative"
        // style={{ borderLeftColor: "#0F3457" }}
        >
            {/* Header */}
            <div className="p-4 border-b border-gray-200 flex items-center justify-between relative">
                <h3 className="text-lg font-semibold text-gray-900">
                    {t("label_detalle")}{' -> '}{itemSelected?.labelPlaca}
                </h3>
                <div className="flex items-center gap-2">
                    {btnConfiguracionPedido === true && (
                        <button
                            ref={buttonRef}
                            onClick={() => setDropdownOpen(!dropdownOpen)}
                            className="p-1 hover:bg-gray-100 rounded-lg transition-colors relative"
                            aria-label={t("label_opciones") || "Opciones"}
                        >
                            <Settings className="h-5 w-5 text-gray-600" />
                        </button>
                    )}
                    <button
                        onClick={onClose}
                        className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
                        aria-label={t("label_cerrar") || "Cerrar"}
                    >
                        <X className="h-5 w-5 text-gray-600" />
                    </button>
                </div>

                {/* Dropdown Menu */}
                {dropdownOpen && (
                    <div
                        ref={dropdownRef}
                        className="absolute right-12 top-16 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50"
                    >
                        <div className="py-1">
                            <button

                                onClick={handleInvertirClick}
                                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                            >
                                {t("label_invertir")}
                            </button>
                            <button

                                onClick={handleDividirClick}
                                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                            >
                                {t("label_dividir")}
                            </button>
                            <button
                                key="ruteo"
                                onClick={handleRuteoClick}
                                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                            >
                                {t("label_ruteo")}
                            </button>
                            <button
                                onClick={handleHojaDeRutaClick}
                                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                            >
                                {t("label_hoja_de_ruta")}
                            </button>
                            <button
                                onClick={() => {
                                    setHojaDeRutaTiemposEntregaModalVisible(true);
                                    setDropdownOpen(false);
                                }}
                                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                            >
                                {t("label_hoja_de_ruta_tiempos_entrega")}
                            </button>
                            {(String(idEmpresa).trim() === String(ID_EMPRESA.PLASTICO).trim() ||
                                String(idEmpresa).trim() === String(ID_EMPRESA.SECOBOL).trim()) &&
                                (
                                    <button
                                        onClick={handleFormularioRetornoClick}
                                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                                    >
                                        {t("label_formulario_retorno")}
                                    </button>
                                )}
                            {(String(idEmpresa).trim() === String(ID_EMPRESA.PLASTICO).trim() ||
                                String(idEmpresa).trim() === String(ID_EMPRESA.SECOBOL).trim()) &&
                                (
                                    <button
                                        onClick={handleCopiarHojaDeRutaClick}
                                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors flex items-center gap-2"
                                    >
                                        <span className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-green-500">
                                            <svg
                                                viewBox="0 0 32 32"
                                                aria-hidden="true"
                                                className="h-3 w-3 text-white"
                                            >
                                                <path
                                                    d="M16 6.4c-4.8 0-8.7 3.8-8.7 8.6 0 1.7.5 3.3 1.4 4.7L8 25.6l6-1.9c1.3.7 2.8 1.1 4.3 1.1 4.8 0 8.7-3.9 8.7-8.6 0-4.7-3.9-8.6-8.7-8.6zm0 15.5c-1.3 0-2.6-.3-3.8-1l-.3-.2-3.5 1.1 1.1-3.4-.2-.3c-.9-1.2-1.3-2.6-1.3-4 0-3.8 3.2-7 7.1-7 3.9 0 7.1 3.1 7.1 7 0 3.8-3.2 6.8-7.1 6.8zm3.9-5.1c-.2-.1-1.2-.6-1.4-.7-.2-.1-.4-.1-.6.1-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.1-.4-2.1-1.3-.8-.7-1.3-1.6-1.5-1.9-.2-.3 0-.4.1-.5.1-.1.3-.3.4-.4.1-.1.2-.2.3-.4.1-.1.1-.3 0-.4-.1-.1-.6-1.5-.8-2-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.4.1-.5.3-.2.3-.7.7-.7 1.8 0 1 .7 2 0.8 2.2.1.2 1.4 2.4 3.4 3.4 2 .9 2 .6 2.4.6.3 0 1.2-.5 1.4-1 .2-.5.2-.9.1-1-.1-.1-.2-.1-.4-.2z"
                                                    fill="currentColor"
                                                />
                                            </svg>
                                        </span>
                                        <span>{t("label_copiar_hoja_de_ruta")}</span>
                                    </button>
                                )}
                        </div>
                    </div>
                )}
            </div>

            {/* Items List Section */}
            <div className="flex-1 overflow-y-auto">
                {items.length === 0 ? (
                    <div className="flex items-center justify-center h-full">
                        <div className="text-gray-500 text-center px-4">
                            {t("label_sin_datos") || "No hay datos disponibles"}
                        </div>
                    </div>
                ) : (
                    <div className="p-2">
                        {items.map((item, index) => {
                            return renderCliente(item, index);
                        })}
                    </div>
                )}
            </div>

            {/* Modal to display selected items */}
            {modalVisible && (
                <div className="fixed z-50 top-0 left-0 right-0 bottom-0 flex items-center justify-center p-4">
                    <div className="fixed inset-0 bg-gray-500 opacity-75" onClick={() => setModalVisible(false)}></div>
                    <div className="bg-white w-11/12 md:max-w-2xl mx-auto rounded shadow-lg z-50 overflow-hidden flex flex-col max-h-[90vh] min-h-[600px]">
                        {/* Modal Header */}
                        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
                            <h3 className="text-lg font-semibold text-gray-900">
                                {t("label_items_seleccionados")}: ({selectedItems.length})
                            </h3>
                            <button
                                onClick={() => setModalVisible(false)}
                                className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
                                aria-label={t("label_cerrar") || "Cerrar"}
                            >
                                <X className="h-5 w-5 text-gray-600" />
                            </button>
                        </div>
                        <div className="px-6 py-4 border-b border-gray-200">
                            <div className="grid grid-cols-12 gap-4">
                                <div className="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">{t("label_vehiculo")}</label>
                                    <Select
                                        options={listaVehiculos}
                                        value={vehiculoSelected}
                                        onChange={(option) => setVehiculoSelected(option)}
                                        placeholder={t("placeholder_seleccione_vehiculo")}
                                        isClearable={true}
                                        isSearchable={true}
                                        classNamePrefix="react-select"
                                    />
                                </div>
                                <div className="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">{t("label_fecha_entrega")}</label>
                                    <Calendar
                                        value={fechaSelected}
                                        onChange={(date) => setFechaSelected(date)}
                                        placeholder={t("placeholder_seleccione_fecha")}
                                        id="fecha_asignacion"
                                        name="fecha_asignacion"
                                    />
                                </div>
                                <div className="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">{t("label_formulario")}</label>
                                    <Select
                                        options={listaFormulario}
                                        value={formularioSelected}
                                        onChange={(option) => setFormularioSelected(option)}
                                        placeholder={t("placeholder_seleccione_formulario")}
                                        isClearable={true}
                                        isSearchable={true}
                                        classNamePrefix="react-select"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Modal Body - List of selected items */}
                        <div className="flex-1 overflow-y-auto px-6 py-4 min-h-0">
                            {selectedItems.length === 0 ? (
                                <div className="text-center text-gray-500 py-8">
                                    {t("label_sin_items_seleccionados")}
                                </div>
                            ) : (
                                <div className="space-y-2">
                                    {selectedItems.map((id, index) => {
                                        const item = items.find(item => item.numeroDocumento === id);
                                        if (!item) return null;
                                        return (
                                            <div
                                                key={id}
                                                className="p-3 bg-gray-50 border border-gray-200 rounded-lg"
                                            >

                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    {t("label_numero_documento")} <span className="text-red-500">*</span>
                                                </label>
                                                <div
                                                    className="text-xs text-gray-500 mt-1 flex items-center gap-2 cursor-pointer hover:text-gray-700 transition-colors"
                                                    onClick={() => {
                                                        if (item.numeroDocumento) {
                                                            navigator.clipboard.writeText(item.numeroDocumento).then(() => {
                                                                if (showToast) {
                                                                    showToast(t("alert_copiado_al_portapapeles"));
                                                                }
                                                            }).catch(err => {
                                                                console.error('Failed to copy:', err);
                                                            });
                                                        }
                                                    }}
                                                    title={t("label_copiar")}
                                                >
                                                    <span>{t("label_numero_documento")}: {item.numeroDocumento}</span>
                                                    <Copy className="h-3 w-3 transition-transform hover:scale-110" />
                                                </div>
                                                <input
                                                    type="text"
                                                    value={item.numeroDocumentoNuevo || ''}
                                                    onChange={(e) => {
                                                        // Update numeroDocumento directly on the item
                                                        item.numeroDocumentoNuevo = e.target.value;
                                                        // Force re-render by updating state
                                                        setForceUpdate(prev => prev + 1);
                                                    }}
                                                    className="w-full p-2 border border-gray-300 rounded-md"
                                                    maxLength={24}
                                                />
                                                <p className="text-sm text-gray-500 flex justify-end">{(item.numeroDocumentoNuevo || 0).length}/24</p>

                                                <div className="flex items-center gap-3">
                                                    <div className="flex-shrink-0 w-8 text-center font-semibold text-gray-700">
                                                        {index + 1}
                                                    </div>
                                                    <div className="flex-1 min-w-0">
                                                        {item.cliente && (
                                                            <div className="text-sm font-medium text-gray-900">
                                                                {item.cliente}
                                                            </div>
                                                        )}
                                                        {/* {item.idGeocerca && (
                                                            <div className="text-xs text-gray-500 mt-1">
                                                                {t("label_geocerca")}: {item.idGeocerca}
                                                            </div>
                                                        )}
                                                        {item.idTipoCliente && (
                                                            <div className="text-xs text-gray-500">
                                                                {t("label_tipo_cliente")}: {item.idTipoCliente}
                                                            </div>
                                                        )} */}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>

                        {/* Modal Footer */}
                        <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
                            <button
                                onClick={() => setModalVisible(false)}
                                className="inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-transparent rounded-md hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-gray-500 transition-colors"
                            >
                                <X className="h-4 w-4 transition-transform hover:scale-110" />
                                {t("label_cerrar")}
                            </button>
                            <button
                                onClick={() => {
                                    handleAceptarModalClick();
                                }}
                                className="inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500 transition-colors"
                            >
                                <Check className="h-4 w-4 transition-transform hover:scale-110" />
                                {t("label_aceptar")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <ModalHojaDeRuta
                visible={hojaDeRutaModalVisible}
                onClose={() => setHojaDeRutaModalVisible(false)}
                items={items}
                t={t}
                selectedDate={selectedDate}
                infoConductor={infoConductor}
            />

            <ModalHojaDeRutaTiemposEntrega
                visible={hojaDeRutaTiemposEntregaModalVisible}
                onClose={() => setHojaDeRutaTiemposEntregaModalVisible(false)}
                items={items}
                t={t}
                selectedDate={selectedDate}
                infoConductor={infoConductor}
            />


            <ModalFormularioRetornoMercaderia
                visible={modalFormularioRetornoVisible}
                onClose={() => setModalFormularioRetornoVisible(false)}
                nombreChofer={infoConductor?.nombreConductor ?? ""}
                placaCamion={itemSelected?.labelPlaca}
                fechaRetorno={moment().format('DD/MM/YYYY')}
                horaRetorno=""
                numeroDocumento={'REG-LOG-02-' + moment(selectedDate).format('YYYYMMDD')}
                rows={rowsFormularioRetorno}
                selectedDate={selectedDate}
            />
        </div>
    );
}

